module.exports = __webpack_public_path__ + "img/kate_macK210737.4e235beb.jpg";